module.exports = __webpack_public_path__ + "img/6fe3c064d906ca4d492848a5feeb5bc3.png";